
import {map} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ProgressService} from "./progress.service";

declare var ENVIRONMENT_CONFIG: any;

@Injectable()
export class FacebookFundraiserService {
    constructor(
        private http: HttpClient,
        private progressService: ProgressService
    ) {}


    facebookFundraiserPageDeleted(facebookFundraiserId) {
        this.progressService.startProgress(false);
        return this.http.get('/api/v1/facebook/fundraisers/' + facebookFundraiserId).pipe(map(res => {return res;}));
    }


    deleteFacebookFundraiserLink(facebookFundraiserId) {
        return this.http.delete('/api/v1/facebook/fundraisers/' + facebookFundraiserId).pipe(map(res => {return res;}));
    }

    createFacebookFundraiser(accessToken, payload) {
        return this.http.post('/api/v1/facebook/fundraisers', payload, {
                headers: new HttpHeaders()
                .set('accessToken', accessToken)});
    }

    getFacebookMessengerLink(program: string, programGroup: string) {
        return this.http.post(ENVIRONMENT_CONFIG.webServicesUrl + '/sys/v1/cfg/', {
            reference: 'FB_CHAT',
            program: program ? program : null,
            program_group: programGroup
        });
    }

    saveConsents(payload) {
        return this.http.post('/api/v1/facebook/fundraisers/consents', payload);
    }

    acknowledgeModal(participantId: number) {

        const key = 'acknowledgedFacebookParticipants';

        let acknowledgedFacebookParticipants;
        try {
            acknowledgedFacebookParticipants = JSON.parse(localStorage.getItem(key));
            acknowledgedFacebookParticipants = acknowledgedFacebookParticipants ? acknowledgedFacebookParticipants : {};
        } catch (e) {
            acknowledgedFacebookParticipants = {};
        }

        acknowledgedFacebookParticipants[participantId] = true;
        localStorage.setItem(key, JSON.stringify(acknowledgedFacebookParticipants));
    }

    isModalAcknowledged(participantId: number) {

        const key = 'acknowledgedFacebookParticipants';

        let acknowledgedFacebookParticipants;
        try {
            acknowledgedFacebookParticipants = JSON.parse(localStorage.getItem(key));
            acknowledgedFacebookParticipants = acknowledgedFacebookParticipants ? acknowledgedFacebookParticipants : {};
        } catch (e) {
            acknowledgedFacebookParticipants = {};
        }
        return acknowledgedFacebookParticipants[participantId];
    }
}
